import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content-static/navigation-menu/chevron-down.svg")